export const ONE_USERS_RESET_STATE = 'ONE_USERS_RESET_STATE';
export const ONE_USERS_CURRENT_ITEM = 'ONE_USERS_CURRENT_ITEM';
 
export const ONE_USERS_REQUEST_LOADING = 'ONE_USERS_REQUEST_LOADING';
export const ONE_USERS_REQUEST_SUCCESS = 'ONE_USERS_REQUEST_SUCCESS';
export const ONE_USERS_REQUEST_FAILED = 'ONE_USERS_REQUEST_FAILED';
 
export const ONE_USERS_CURRENT_ACTION = 'ONE_USERS_CURRENT_ACTION';
export const ONE_USERS_RESET_ACTION = 'ONE_USERS_RESET_ACTION';